// extracted by mini-css-extract-plugin
export default {"special-text":"PositionTemplate_special-text__waSyO"};